import { useAppDispatch, useAppSelector } from '../../../../App/redux/store';
import ActionModal from '../../../modals/components/actionModal/ActionModal';
import { getModalsState, modalsActions } from '../../../modals/modalsSlice';
import { deleteFolderThunk } from '../../services/foldersThunks';

import './folderDeleteModal.scss';

const FolderDeleteModal = () => {
  const { deleteFolder } = useAppSelector(getModalsState);
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(deleteFolderThunk({ folder: deleteFolder }));
  };
  const handleClose = () => {
    dispatch(modalsActions.deleteFolder(null));
  };

  return (
    <ActionModal
      closeAction={handleClose}
      validAction={handleDelete}
      validText="SUPPRIMER"
      modalType="suppression"
    >
      <p>
        Confirmez-vous la suppression du dossier
        <span>{` ${deleteFolder?.name} `}</span> et de tout son contenu ?
      </p>
      <p>La suppression sera définitive.</p>
    </ActionModal>
  );
};

export default FolderDeleteModal;
